import { pathOr } from "ramda";
import { inject, ref } from "vue";
import { asyncLocalStorage } from "./utils";
// import Uppy from "@uppy/core";
// import Tus from "@uppy/tus";
// import GoldenRetriever from "@uppy/golden-retriever";

export const useError = () => {
  const generateError: any = inject("generateError");
  return { generateError };
};

export const useLanguage = () => {
  const generateLanguage: any = inject("generateLanguage");
  return { generateLanguage };
};

export const useToast = () => {
  const toastAlert: any = inject("toastAlert");
  return { toastAlert };
};

export const useApiUrl = () => {
  const generateApiUrl: any = inject("generateApiUrl");
  return { generateApiUrl };
};

export const useYupSchema = () => {
  const createYupSchema: any = inject("createYupSchema");
  return { createYupSchema };
};

export const useConfig = () => {
  const config: any = inject("config");
  const generateConfig = (key: any) => {
    return pathOr("", key, config);
  };
  return { generateConfig };
};

export const useNotify = () => {
  const notify: any = inject("notify");
  return { notify };
};

export const useState = (initialValue: any = null) => {
  const state = ref(initialValue);
  const setState = (val: any) => (state.value = val);
  return [state, setState];
};

let dbInstance: any = null;

const openDB = (dbName: any, storeName: any) => {
  if (dbInstance) return Promise.resolve(dbInstance);

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, 1);

    request.onerror = () => {
      reject("Error opening database");
    };

    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: "id" });
      }
    };

    request.onsuccess = (event: any) => {
      // set expire time
      const nowTime: any = Date.now();
      localStorage.setItem("db-images-expire", nowTime);

      dbInstance = event.target.result;
      resolve(dbInstance);
    };
  });
};
export const useIndexedDB = (
  dbName: any,
  storeName: any,
  expirationTime: any = 3600000
) => {
  const checkExpired = async () => {
    const expiredAt: any =
      (await asyncLocalStorage.getItem("db-images-expire")) || Date.now();

    if (Date.now() - expiredAt > expirationTime) {
      indexedDB.deleteDatabase(dbName);
    }
  };

  const addItem = async (item: any) => {
    try {
      await checkExpired();
      const db: any = await openDB(dbName, storeName);
      const transaction = db.transaction(storeName, "readwrite");
      const store = transaction.objectStore(storeName);
      store.add(item);
    } catch (error) {}
  };

  const getItem = async (id: any) => {
    await checkExpired();
    const db: any = await openDB(dbName, storeName);
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);
    return new Promise((resolve, reject) => {
      const request = store.get(id);
      request.onsuccess = () => {
        resolve(request.result);
      };
      request.onerror = () => {
        reject("Error getting item");
      };
    });
  };

  const checkItemExists = async (id: any) => {
    const item = await getItem(id);
    return item !== undefined;
  };

  const deleteItem = async (id: any) => {
    const db: any = await openDB(dbName, storeName);
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);
    store.delete(id);
  };

  return {
    addItem,
    getItem,
    checkItemExists,
    deleteItem,
  };
};

export const useHooks = () => {
  const generateConfig: any = inject("generateConfig");
  const generateCustom: any = inject("generateCustom");
  const generateError: any = inject("generateError");
  const generateLanguage: any = inject("generateLanguage");
  const toastAlert: any = inject("toastAlert");
  const generateApiUrl: any = inject("generateApiUrl");
  const createYupSchema: any = inject("createYupSchema");
  const lazyLoadElement: any = inject("lazyLoadElement");
  const useState: any = inject("useState");
  const useMobile: any = inject("useMobile");

  return {
    generateConfig,
    generateError,
    generateLanguage,
    toastAlert,
    generateApiUrl,
    createYupSchema,
    generateCustom,
    lazyLoadElement,
    useState,
    useMobile,
  };
};

// const useUppy = (options = {}) => {
//   const uppy = new Uppy({
//     debug: true,
//     autoProceed: false,
//     restrictions: {
//       maxFileSize: 10000000,
//       maxNumberOfFiles: 10,
//     },
//     ...options,
//   });

//   const { toastAlert } = useHooks();

//   const files: any = ref([]);
//   const errorMessage = ref("");

//   uppy
//     .use(Tus, {
//       endpoint: "YOUR_TUS_SERVER_ENDPOINT", // سرور tus خود را وارد کنید
//       chunkSize: 1024 * 1024, // اندازه چانک‌ها (1MB)
//       retryDelays: [0, 1000, 3000, 5000, 10000],
//       withCredentials: true,
//       onError: (error) => {
//         console.error("خطا در آپلود:", error);
//         toastAlert("خطا در آپلود!", "error");
//       },
//       onProgress: (file: any, { bytesUploaded, bytesTotal }: any) => {
//         const progress = Math.round((bytesUploaded / bytesTotal) * 100);
//         const fileIndex = files.value.findIndex((f: any) => f.id === file.id);
//         if (fileIndex > -1) {
//           files.value[fileIndex].meta.progressWidth = progress;
//         }
//       },
//     })
//     .use(GoldenRetriever, { serviceWorker: true, expires: 2 * 60 * 60 * 1000 });

//   const addFile = (file: any) => {
//     uppy.addFile({
//       name: file.name,
//       type: file.type,
//       data: file,
//       meta: {
//         caption: file.name,
//       },
//     });
//     uppy.upload();
//   };

//   const removeFile = (id: any) => {
//     uppy.removeFile(id);
//     files.value = files.value.filter((f: any) => f.id !== id);
//   };

//   const pauseFile = (id: any) => {
//     uppy.pauseResume(id);
//   };

//   const resumeFile = (id: any) => {
//     uppy.pauseResume(id);
//   };

//   const retryUpload = (id: any) => {
//     uppy.retryUpload(id);
//   };

//   onMounted(() => {
//     uppy.on("file-added", (file) => {
//       files.value.push(file);
//     });
//     uppy.on("upload-progress", (file: any, progress: any) => {
//       const fileIndex = files.value.findIndex((f: any) => f.id === file.id);
//       if (fileIndex > -1) {
//         files.value[fileIndex].meta.progressWidth = Math.round(
//           (progress.bytesUploaded / progress.bytesTotal) * 100
//         );
//       }
//     });
//   });
// };
